import { api } from "./client";
import type {
  DocumentRelationshipDto,
  DocumentRelationshipKind,
} from "@/types/documentRelationships";

export const documentRelationshipsApi = {
  list: (documentId: string, includeArchived = false) =>
    api.get<DocumentRelationshipDto[]>(
      `/documents/${documentId}/relationships`,
      includeArchived ? { includeArchived: true } : undefined,
    ),
  create: (documentIds: string[], kind: DocumentRelationshipKind) =>
    api.post<DocumentRelationshipDto[]>("/documents/relationships", {
      documentIds,
      kind,
    }),
  remove: (id: string) => api.delete<void>(`/documents/relationships/${id}`),
};
